export const setAssetsAction = (assets) => (
    {
        type: '_assets_Set',
        payload: assets
    }
)
